import "./fairness.css";
import {
  profilePurpleIcons,
  profileFilledDarkIcons,
} from "../../utils/globalImages";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Container, Form } from "react-bootstrap";
import Toaster from "../../components/Toast/Toast";
import { Fairness, PostSeed } from "../../api/modules/b2droppie.class";
import BackdropLoader from "../../components/BackdropLoader/BackdropLoader";

const MyAccount = () => {
  const [seed, setSeed] = useState(0);
  const [loading, setLoading] = useState(true);
  const [clientSeedValue, setClientSeedValue] = useState("");
  const [error, setError] = useState({ success: "", error: "" });
  const isDarkMode = useSelector((state) => state.theme.darkMode);

  useEffect(() => {
    try {
      setLoading(true);
      const api = async () => {
        const res = await Fairness();
        setClientSeedValue(res?.data?.data?.client_seed);
      };
      api();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [seed]);

  const handleChange = (event) => {
    setClientSeedValue(event.target.value);
  };

  const handleClick = async () => {
    try {
      setLoading(true);
      const response = await PostSeed({ client_seed: clientSeedValue });

      setError({
        success: response?.data?.message || "Request Submitted Successfully",
        error: "",
      });
    } catch (err) {
      setError({
        success: "",
        error:
          err.response?.data?.error?.client_seed?.[0] || "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Toaster message={error} />
      <div className={`fairness-header ${isDarkMode ? "dark" : "light"}`}>
        <div className="fairness-header-left">
          <div className="fairness-icon">
            <img
              src={
                isDarkMode
                  ? profileFilledDarkIcons.justiceScaleFilledDark
                  : profilePurpleIcons.justiceScaleFilledPurple
              }
              alt="justice-scales"
            />
          </div>
          <div className="fairness-header-text">
            <h1
              className={`fairness-title-header ${isDarkMode ? "text-white" : "text-deep-purple"}`}
            >
              Fairness
            </h1>
            <p
              className={`fairness-subtitle-header ${isDarkMode ? "text-light-gray" : "text-silver-gray"}`}
            >
              Hashed server seeds, your choice — fairness by Droppie.
            </p>
          </div>
        </div>
      </div>
      <div className={`fairness-card ${isDarkMode ? "dark" : "light"}`}>
        <p
          className={`fairness-description ${isDarkMode ? "text-light-gray" : "text-charcoal-gray"
            }`}
        >
          Droppie uses a simple system to verify game fairness. Server seeds are
          hashed and displayed before each game, and users can choose any seed
          they prefer.
        </p>

        <Form.Group className="formgroup">
          <Form.Label
            className="label"
            style={{ color: isDarkMode ? "#808080" : "#49454f" }}
          >
            Current Server Seed (Hashed)
          </Form.Label>
          <Form.Control
            disabled
            readOnly
            type="text"
            // value={clientSeedValue?.server_seed}
            value="3b79a56f040e384220d5d8c17834b017e9f9da348f3bfb7cd86d4644bb61ad8d"
            className={`cursor-disabled border-0 ${isDarkMode ? "bg-jet-black" : "bg-light"}`}
          />
        </Form.Group>

        <Form.Group className="formgroup mt-4">
          <Form.Label
            style={{ color: isDarkMode ? "#808080" : "#49454f" }}
            className="label"
          >
            Your Client Seed
          </Form.Label>
          <Form.Control
            type="text"
            onChange={handleChange}
            value={clientSeedValue}
            placeholder="Enter your client seed"
            className={`text-medium-gray border-0 ${isDarkMode ? "bg-jet-black" : "bg-light"}`}
          />
          <div className="d-end mt-4">
            <button
              onClick={handleClick}
              className="w-10 w-md-100 filled-medium-deep-yellow-btn-dark "
            >
              Change
            </button>
          </div>
        </Form.Group>
      </div>

      <div className="logout-button-section mt-3 mb-3">
        {/* <button className="logout-button" onClick={handleLogout}>
          <span>log out</span>
        </button> */}
      </div>
      <BackdropLoader show={loading} />
    </>
  );
};

export default MyAccount;
